import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { postInterest, putInterest } from '../../actions';
import { removeFromQuery } from '../../../helpers';
import pickerWrapper from './pickerWrapperHOC';
import InputTitleInterest from './InputTitleInterest';
import TournamentPicker from '../../../components/pickers/TournamentPicker';
import TeamPicker from '../../../components/pickers/TeamPicker';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import AddedItemsList from './AddedItemsList';

const AddedItemsListWrapper = styled.div`
    display: flex;
    justify-content: space-between;

    & > * {
        flex-basis: calc(50% - 15px);
        width: calc(50% - 15px);
        max-width: calc(50% - 15px);
    }
`;

const TournamentPickerInterest = pickerWrapper(TournamentPicker, 'tournament');
const TeamPickerInterest = pickerWrapper(TeamPicker, 'teamIds');

class AddInterestFormDialog extends Component {
    state = {
        name: this.props.interest.name !== undefined ? this.props.interest.name : '',
        ttIds: this.props.interest.ttIds !== undefined ? new Set(this.props.interest.ttIds) : new Set(),
        teamIds: this.props.interest.teamIds !== undefined ? new Set(this.props.interest.teamIds) : new Set(),
        loading: false,
        error: false
    };

    componentWillReceiveProps({ interest }) {
        if (
            interest.name !== this.props.interest.name ||
            interest.ttIds.toString() !== this.props.interest.ttIds.toString() ||
            interest.teamIds.toString() !== this.props.interest.teamIds.toString()
        ) {
            this.setState({
                name: interest.name !== undefined ? interest.name : '',
                ttIds: interest.ttIds !== undefined ? new Set(interest.ttIds) : new Set(),
                teamIds: interest.teamIds !== undefined ? new Set(interest.teamIds) : new Set()
            });
        }
    }

    handleClose = () => {
        this.setState({
            name: '',
            ttIds: new Set(),
            teamIds: new Set()
        });
        removeFromQuery('addInterestDialog');
    };

    setInterestName = ({ target }) => {
        this.setState({ name: target.value });
    };

    onClickSaveBtnPicker = type => value => {
        this.setState(state => ({ [type]: new Set(state[type].add(value)) }));
    };

    handleDeleteItem = type => value => () => {
        this.setState(state => {
            const newState = new Set(state[type]);
            newState.delete(value);

            return { [type]: new Set(newState) };
        });
    };

    onSaveForm = () => {
        if (this.props.interestId !== 'newInterest') {
            this.props.putInterest(this.props.interestId, {
                name: this.state.name,
                ttIds: [...this.state.ttIds],
                teamIds: [...this.state.teamIds]
            });
        } else {
            this.props.postInterest({
                name: this.state.name,
                ttIds: [...this.state.ttIds],
                teamIds: [...this.state.teamIds]
            });
        }

        this.handleClose();
    };

    render() {
        const { open = false, interestId = '', tournaments = {}, teams = {} } = this.props;
        const { name = '', ttIds = new Set(), teamIds = new Set(), loading = false, error = false } = this.state;

        const actions = [
            <FlatButton key="Cancel" label="Cancel" secondary onClick={this.handleClose} />,
            <FlatButton
                key="Submit"
                label={interestId === 'newInterest' ? 'Submit' : 'Edit'}
                primary
                disabled={!name || (ttIds.size || teamIds.size) === 0}
                onClick={this.onSaveForm}
            />
        ];

        return (
            <Dialog
                title={interestId === 'newInterest' ? 'New interest' : 'Edit interest'}
                actions={actions}
                modal={false}
                open={open}
                onRequestClose={this.handleClose}
                autoScrollBodyContent
            >
                <div>
                    {loading && <h1>Loading</h1>}
                    {error && <h1 style={{ color: 'red' }}>Error</h1>}
                    <InputTitleInterest value={name} onSave={this.setInterestName} />
                    {(Boolean(ttIds.size) || Boolean(teamIds.size)) && (
                        <AddedItemsListWrapper>
                            {Boolean(ttIds.size) && (
                                <AddedItemsList
                                    title="Tournaments: "
                                    itemIdList={[...ttIds]}
                                    mapItems={tournaments}
                                    handleDeleteItem={this.handleDeleteItem('ttIds')}
                                />
                            )}
                            {Boolean(teamIds.size) && (
                                <AddedItemsList
                                    title="Teams: "
                                    itemIdList={[...teamIds]}
                                    mapItems={teams}
                                    handleDeleteItem={this.handleDeleteItem('teamIds')}
                                />
                            )}
                        </AddedItemsListWrapper>
                    )}
                    <TournamentPickerInterest hideSeasonPicker onClickSaveBtn={this.onClickSaveBtnPicker('ttIds')} />
                    <TeamPickerInterest onClickSaveBtn={this.onClickSaveBtnPicker('teamIds')} />
                </div>
            </Dialog>
        );
    }
}

AddInterestFormDialog.defaultProps = {
    interestId: 'newInterest',
    interest: {
        name: '',
        ttIds: [],
        teamIds: []
    }
};

AddInterestFormDialog.propTypes = {
    open: PropTypes.bool,
    interestId: PropTypes.string,
    interest: PropTypes.shape({
        name: PropTypes.string,
        ttIds: PropTypes.array,
        teamIds: PropTypes.array
    }),
    tournaments: PropTypes.object,
    teams: PropTypes.object,
    postInterest: PropTypes.func.isRequired,
    putInterest: PropTypes.func.isRequired
};

export default connect(
    ({ routing, requery }) => {
        const interestId = routing.location && routing.location.query && routing.location.query.addInterestDialog;
        const interest =
            requery.entities && requery.entities.userInterests && requery.entities.userInterests[interestId];

        return {
            open: Boolean(interestId),
            interestId,
            interest,
            tournaments: requery.entities && requery.entities.tournaments,
            teams: requery.entities && requery.entities.teams
        };
    },
    { postInterest, putInterest }
)(AddInterestFormDialog);



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/AddInterestFormDialog/index.js
 **/